import React from "react";
import DisplayConnectionIcon from "./components/DisplayConnectionIcon";
import { Container, FlexRow, SocialMediaButton } from "./AccountLinkingPage";
import { Text } from "src/components";

const SocialMediaRow = (props) => {
    const { logo, pageItem, isExpiredPage } = props;

    return (
        <Container style={{ marginTop: "10px", marginBottom: "10px" }}>
            <FlexRow>
                <SocialMediaButton width="267px" backgroundColor="#fff" color="#000" border="1px solid #D8DEEC;">
                    <img src={logo} alt="Social Platform Icon" style={{ marginRight: "12px", borderRadius: "50%", width: "33.346px", height: "33.346px" }} />
                    {pageItem.pageName}
                </SocialMediaButton>
                { DisplayConnectionIcon(isExpiredPage) }
                {isExpiredPage && <Text size="14px" weight="500" color="black">&nbsp;Expired</Text>}
            </FlexRow>
        </Container>
    );
};

export default SocialMediaRow;
